if (!customElements.get('nat-card-gallery')) {
  customElements.define('nat-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.nat-card-gallery__track');
      const dots = [...this.querySelectorAll('[data-photo]')];
      if (!track || !dots.length) return;
      let startX = 0, startY = 0, moved = false;
      const update = () => {
        const box = track.getBoundingClientRect();
        let index = 0, distance = Infinity;
        [...track.children].forEach((slide, i) => {
          const r = slide.getBoundingClientRect();
          const delta = Math.abs((r.left + r.right) - (box.left + box.right));
          if (delta < distance) { distance = delta; index = i; }
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      };
      const go = index => {
        const slide = track.children[index];
        if (!slide) return;
        track.scrollBy({ left: slide.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      dots.forEach((dot, i) => dot.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); go(i); }, options));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
      }, { ...options, passive: true });
      track.addEventListener('pointerdown', e => { startX = e.clientX; startY = e.clientY; moved = false; }, { ...options, passive: true });
      track.addEventListener('pointermove', e => { if (Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8) moved = true; }, { ...options, passive: true });
      track.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, { ...options, capture: true });
      track.addEventListener('keydown', e => {
        if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        e.preventDefault();
        const index = dots.findIndex(dot => dot.getAttribute('aria-pressed') === 'true');
        const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        go(Math.max(0, Math.min(dots.length - 1, index + (e.key === 'ArrowRight' ? direction : -direction))));
      }, options);
      this.resize = new ResizeObserver(update);
      this.resize.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.resize?.disconnect(); cancelAnimationFrame(this.frame);
    }
  });
}
